import { Box, Popover } from "@mui/material";
import React from "react";

import { useReceiptActions } from "../../../components/receipts/ReceiptActions";
import { openWhatsapp } from "../../../helpers";

/**
 * Purchase details › "⋯" menu: Contact the member, or email them the receipt of this purchase (2026-11-02).
 * "Email receipt" opens the same pop-up as Revenue / the member page (payments/paymentReceipt with { purchaseId }),
 * it used to send a class booking confirmation from a Mailjet template.
 */
export default function PurchaseDetailActionPopover({
  purchasingDetails,
  handleUpdate,
  anchorEl,
  setAnchorEl
}) {
  const receipts = useReceiptActions();
  const { purchaseId } = purchasingDetails;
  const username = purchasingDetails?.consumer_detail?.username;
  const email = purchasingDetails?.consumer_detail?.email;
  const isPaid = (["paid", "refund-pendding", "refunded"].indexOf(purchasingDetails?.paymentStatus?.toLowerCase()) > -1) ? true : false;

  const handleClose = () => {
    setAnchorEl(null);
  };

  const popoverOpen = Boolean(anchorEl);
  const popoverId = popoverOpen ? "simple-popover" : undefined;

  const emailReceipt = () => {
    handleClose();
    receipts.email({ purchaseId });
  };

  const handleContactClick = () => {
    handleClose();
    if (email) {
      window.open(`mailto:${email}`);
    } else {
      const usernameCopy = username || "";
      const number = usernameCopy.replace(/[^\w\s]/gi, "").replace(/ /g, "");
      openWhatsapp(number);
    }
  };

  const popoverOptions = [
    {
      text: "Contact",
      onClick: handleContactClick,
      disabled: false,
    },
    {
      text: "Email receipt",
      onClick: emailReceipt,
      disabled: !isPaid || !purchaseId,
    },
  ];

  return (

    <Box>
      <Popover
        id={popoverId}
        open={popoverOpen}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        sx={{
          my: 1,
          "& .MuiPopover-paper": {
            boxShadow: "none",
            border: 1,
            borderColor: "#EBEBEB",
            borderRadius: 3,
          },
        }}
      >
        <div className={"flex flex-col gap-3 py-5"}>
          {popoverOptions.map((opt, idx) => (
            <button
              key={idx}
              disabled={opt.disabled}
              className={`flex flex-row justify-between items-center gap-4 cursor-pointer px-8 py-2 transition-all ${opt.disabled
                ? ""
                : "active:bg-light-brown-coffee active:text-white"
                } disabled:opacity-60 disabled:cursor-default`}
              onClick={opt.onClick}
            >
              <p className={"text-sm"}>{opt.text}</p>
            </button>
          ))}
        </div>
      </Popover>

      {receipts.modal}
    </Box>
  );
}
